import { IEcommerceAnswerSchema } from '../types'

// A product is discounted when its discounted price is set and below the regular one. No discount is
// stored as 0, not null, so the value itself cannot serve as the flag.
export const hasDiscount = (answer: IEcommerceAnswerSchema): boolean =>
  Boolean(answer.discounted_price) && answer.price > answer.discounted_price
